<div class="location-sort">
    <label for="locationUsersSort" class="form-label"><strong>{{localize(langSection.LocationUserPage, langText.SortLocationsBy)}}</strong></label>
    <div class="sort-controls">
        <ups-select name="locationUsersSort" [list]="sortOptions" [value]="selectedSort" (change)="updateLocationSort($event.target.value)">
        </ups-select>
        <button aria-label="Ascending or Descending" class="up-and-down-sort btn" type="button" (click)="toggleAscending()"></button>
    </div>
</div>